<template lang="pug">
ul.collapsible
  li(v-for="(c,i) in capabilities")
    div.collapsible-header
      div.color-stripe(:class="i%2?'white':'grey'")
        img.icon(:src="require('../assets/icons/'+c.icon)")
        div.title-container
          span.title {{c.title}}
      div.plus-button-container
        span.plus-button
    div.collapsible-body
      div.content(v-html="c.content")
      div.content-mobile(v-html="c.contentMobile")
</template>
<script>
export default {
  mounted() {
    $(".collapsible").collapsible();
  },
  data() {
    return {
      capabilities: [
        {
          title: "audience intelligence",
          icon: "Asset 1.svg",
          content:
            "audience research & insights • <br>audience segmentation & targeting • persona development",
          contentMobile:
            "audience research & insights • <br>audience segmentation & targeting • <br>persona development",
        },
        {
          title: "Strategy",
          icon: "Asset 2.svg",
          content:
            "brand strategy • market positioning • <br>integrated marketing strategy • creative strategy • <br>channel planning",
          contentMobile:
            "brand strategy • market positioning • <br>integrated marketing strategy • <br>creative strategy • channel planning",
        },
        {
          title: "Creative Development",
          icon: "Asset 3.svg",
          content:
            "storytelling • core creative idea • branded content • <br>brand identity • design • naming • 360 marketing: print • <br>outdoor • social • mobile • digital • email",
          contentMobile:
            "storytelling • core creative idea • branded<br>content • brand identity • design • naming •<br>360 marketing: print • outdoor • social • <br>mobile • digital • email",
        },
        {
          title: "digital",
          icon: "Asset 4.svg",
          content:
            "strategy • creative • listening • measurement: paid social • <br>search & programmatic",
          contentMobile:
            "strategy • creative • listening • measurement: <br>paid social • search & programmatic",
        },
        {
          title: "production & post-production",
          icon: "Asset 5.svg",
          content:
            "content production • experiential & event production • <br>post-production • celebrity talent & influencers negotiations • <br> securing music licenses & obtaining intellectual property  <br> rights for brands",
          contentMobile:
            "content production • experiential & event <br>production • post-production •<br> celebrity talent & influencers negotiations • <br> securing music licenses & obtaining <br> intellectual property  rights for brands",
        },
      ],
    };
  },
};
</script>

<style lang="sass">
#capabilities-list
  .icon
    width: 5%
    height: auto
    margin-right: 4%
  .col
    padding: 0 !important
  .collapsible
    border: 0
    .collapsible-body
      width: 100vw
      padding: 0
      border-bottom: 0
      margin-bottom: 20px
      span.title
        color: white
    .collapsible-header
      background-color: transparent
      font-size: 100%
      line-height: 100%

      border: 0
      margin-bottom: 20px
      padding: 0
      display: flex
      align-items: center
      div.color-stripe
        width: 30vw
        padding: 4px 20px;
        display: flex
        justify-content: flex-start
        align-items: center
      div.plus-button-container
        span.plus-button
          width: 2vw
          margin-left: 20px
          font-family: 'Fjalla One', sans-serif
          font-size: 70%
          line-height: 0%
          font-weight: 100
          color: #00FFFF
          text-align: center
        span.plus-button::after
          content: '+'
      div.color-stripe.grey
        background-color: grey
      div.color-stripe.white
        background-color: white
        span.title
          color: black
    .collapsible-header.active
      div.plus-button-container
        span.plus-button::after
          content: '-'
          text-align: center
      div.color-stripe
        width: 30vw
        background-color: #00FFFF !important
        span.title
          color: black
      div.color-stripe.white
        background-color: #00FFFF
        .icon
          -webkit-filter: none
          filter: none
      div.color-stripe.grey
        .icon
          -webkit-filter: invert(100%)
          filter: invert(100%)
  p
    margin: 0
  span.title
    color: white
    text-transform: uppercase
    font-family: 'Fjalla One', sans-serif
    font-size: 50%
    line-height: 100%
  div.content
    color: white
    font-family: GothamItalic
    font-size: 30%
    font-weight: 100
    display: block
  div.content-mobile
    display: none
@media (max-device-width: 769px)
  #capabilities-list
    .icon
      width: 7%
    .collapsible
      .collapsible-header.active
        div.color-stripe
          width: 72vw
      .collapsible-body
        margin-bottom: 30px
      .collapsible-header
        margin-bottom: 30px
        div.color-stripe
          width: 72vw
          padding: 30px 20px
        div.plus-button-container
          span.plus-button
            font-size: 45px
          span.plus-button::after
            font-size: 45px
            margin-bottom: -45px
      div.title-container
        display: flex
        align-items: center
        span.title
          font-size: 45px
          line-height: 45px
          height: 45px
          margin: 0
          padding: 0
          width: 80vw
      div.content
        display: none
      div.content-mobile
        color: white
        font-family: GothamItalic
        font-weight: 100
        display: block
        font-size: 35px

#capabilities-list
  div.title-container
    padding: 20px 0px
    position: relative
    span.title
      position: absolute
      width: 25vw
      top: 50%;
      transform: translate(0%, -50%);

@supports (-webkit-touch-callout: none)
  /* CSS specific to iOS devices */
  #mobileApp
    #capabilities-list
      span.title
        margin-bottom: -35px
@supports not (-webkit-touch-callout: none)
  /* CSS for other than iOS devices */
  #mobileApp
    #capabilities-list
      span.title
        margin-bottom: -10px
</style>



// WEBPACK FOOTER //
// src/components/capabilities.vue